<template>
  <div class="text-base md:text-lg">
    <!-- HERO -->
    <HeroJob :data="page" />

    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <!-- LEAD -->
    <div v-if="page.lead" class="pt-10 sm:pt-12 md:pt-14 lg:pt-16 xl:pt-20">
      <LeadText :lead="page.lead" />
    </div>

    <!-- COMPONENT LOADER -->
    <ComponentsLoader v-if="page.components" :components="page.components" />

    <!-- CONTACT TEASER -->
    <ContentContactTeaser v-if="page.person" :data="page" />
  </div>
</template>

<script setup>
const props = defineProps({
  page: { type: Object, required: true },
})

const route = useRoute()
const parentPath = route.path.substring(0, route.path.lastIndexOf('/'))
const breadcrumbs = [
  ...useBreadcrumbs(parentPath),
  {
    url: null,
    title: props.page.title,
  },
]
</script>
